var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnicorn = function SvgUnicorn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16,
    "data-token-category": "Icons",
    "data-token-description": "Unicorn icon (custom)",
    "data-token-name": "Icon Unicorn",
    viewBox: "0 0 400 400"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88 320.449c21.046-27.046 44.69-68.218 60.633-98.615 19.416-37.023 20.031-32.628 24.52-75.08.15-1.41 4.321-29.078 6.758-28.271q11.832 3.924 17.568 47.083 118.503 42.304 114.41 62.664c-2.901 14.433-20.595 56.957-43.306 33.865-5.12-5.206-1.686-19.161-6.583-19.161s-34.462-10.784-35.322-9.925c-1.021 1.012 7.002 73.705 2.938 102"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M196.25 148.774c30.56-74.607 15.142 11.069 12.161 19.236M217.762 168.01c20.658-27.804 76.814-105 85.235-104 .459.054-41.275 77.737-62.672 116M151 205.703c-14.764-.188-29.636-.692-44 2.752M138 236.01c-12.141.894-26.438.991-37 5M123 268.16c-9.041-1.337-30.496 6.687-32 6.85M211 197.73v-3.44"
  })));
};
export default SvgUnicorn;